import React,{useState,useEffect,useRef} from 'react';
import {Button, Dialog,DialogActions,DialogContent, DialogTitle,} from "@material-ui/core";
import { Checkbox, FormControlLabel, IconButton,Tooltip,Fab } from '@material-ui/core';
import {Close, Save} from '@material-ui/icons';import SecondaryButton from '../SecondaryButton';
import realtimeDB, { db, storage } from '../../Utils/api';
import OpcionesModal from './OpcionesModal';
import Input from '../Input';
import { useHistory } from 'react-router-dom';
import {useDropzone} from 'react-dropzone'
import styled from "styled-components";
import uploadImage from '../../Utils/uploadImage';
import { isElementOfType } from 'react-dom/test-utils';

const ContainerDropZone=styled.div`
margin:10px;
border:3px dashed;`;

const ContainerImage=styled.div`
position:relative;
display:grid;`;


const TextoDropZone=styled.p`
margin:0px;
padding:5% 10%;
text-align:center;`;


const ImagenUI=styled.img`
width:100%;`;

const ImgPreview=styled.img`
margin:15px auto;
width:100%;
height:25vh;`;

const RemoveDialog=({open,close,item})=>
{
    const handleRemove=async ()=>
    {
        await realtimeDB.ref(`/Menu/CategoriasDOS/${item.data.Categoria}/Items/${item.id}`).remove();
        close();
    }

    return <Dialog open={open} onClose={close}>
    <DialogTitle>{`Desea eliminar ${item.data.Nombre}?`}</DialogTitle>
    <DialogActions>
        <Button variant="outlined" style={{color:"black"}} onClick={close}>Cancelar</Button>
        <Button variant="contained" style={{backgroundColor:"rgb(0, 136, 255)",color:"white"}} onClick={handleRemove}>Confirmar</Button>
    </DialogActions>
</Dialog>
}

const EditItem = ({open,close,item}) => 
{
    const DefaultImage="https://baumlanus.s3.sa-east-1.amazonaws.com/Imagen_no_disponible_41b46cb63f.jpg";
    const {id,data}=item;
    
    const [Nombre, setNombre] = useState(data.Nombre);
    const [Precio, setPrecio] = useState(data.Precio);
    const [Descripcion, setDescripcion] = useState(data.Descripcion);
    const [Indice, setIndice] = useState(data.Indice);
    const [VariablesSimultaneas, setVariablesSimultaneas] = useState(data.VariablesSimultaneas);
    const [Imagen, setImagen] = useState(data.Imagen);
    const [Opciones, setOpciones] = useState(data.Opciones);
    const [ImagenSubir, setImagenSubir] = useState(undefined);
    const [EliminarOpen,setEliminarOpen] = useState(false);

    const cancel=()=>
    {
        setNombre(data.Nombre);
        setPrecio(data.Precio);
        setDescripcion(data.Descripcion);
        setImagen(data.Imagen);
        close();
    }

    const Confirm=async ()=>
    {
        const ItemRef= realtimeDB.ref("/Menu/CategoriasDOS").child(data.Categoria).child("Items").child(id);
 
        if(Imagen === data.Imagen)
        {   
            await ItemRef.update
            ({
                 Nombre,
                 Indice,
                 Precio:Number(Precio),
                 Descripcion,
                 VariablesSimultaneas
             });
         }
         else
         {
             var imagenURL = DefaultImage;
 
             if(ImagenSubir)
             {
                 const Subida=await uploadImage(ImagenSubir);
                 if(Subida.status===200)
                 {
                     imagenURL=Subida.path;
                 }
             }
             
             await ItemRef.update
             ({
                 Nombre,
                 Indice,
                 Estado:true,
                 Precio:Number(Precio),
                 Descripcion,
                 Imagen:imagenURL,
                 VariablesSimultaneas
             });
         }
        close();
    }
    
    const SwitchState=()=>
    {
        const handleNewState=async()=>       
        {
            await realtimeDB.ref("/Menu/CategoriasDOS").child(data.Categoria).child("Items").child(id).update({Estado: !data.Estado});
        }
 
        return <Button onClick={handleNewState} variant="outlined" color="secondary">{data.Estado ? "Desactivar" : "Activar"}</Button>
    }
    
    const RedirectToVariables=()=>
    {
       const win = window.open(`/admin/menu/${data.Categoria}/${id}/variables`, "_blank");
       win.focus();
    }

    const DropZone= () => 
    {
        const UploadImage=()=>
        {
            const {getRootProps, getInputProps,isDragActive} = useDropzone({maxFiles:1,accept:"image/*", onDrop: imagenes=>
            {
                const imagen=imagenes.map( imagen => Object.assign(imagen,{preview: URL.createObjectURL(imagen)}))[0];
                setImagenSubir(imagen);
                setImagen(imagen.preview);
            }});
            
            return <section className="container">
                <ContainerDropZone {...getRootProps({className: 'dropzone'})}>
                    <input {...getInputProps()} />
                    {isDragActive ? <TextoDropZone>Suelta la imagen</TextoDropZone> : <TextoDropZone>Arrastrá o clickeá</TextoDropZone>}
                </ContainerDropZone>
            </section>
        }

        const PreviewImage=()=>
        {
            const DeleteImage = async () => 
            {
                const ItemRef= realtimeDB.ref("/Menu/CategoriasDOS").child(data.Categoria).child("Items").child(id);
                setImagen(undefined)
            }

            return <ContainerImage>
                <ImgPreview src={Imagen}/>
                <Tooltip title="Remover imagen">
                    <IconButton onClick={DeleteImage} style={{position:"absolute",top:0,right:0}} >
                        <Close/>
                    </IconButton>
                </Tooltip>
            </ContainerImage>
        }

        if(Imagen===undefined || Imagen===null)
        {
            return <UploadImage/>
        }

        return <PreviewImage/>
    }


   return <>
   <Dialog open={open} onClose={close}>
       <DialogContent>
            <DropZone/>
           <div style={{display:"grid",gridTemplateColumns:"auto auto",margin:"10px 0"}}>
                <Input label="Nombre" value={Nombre} changeValue={setNombre}/>
                <Input type="number" label="Precio" value={Precio} changeValue={setPrecio}/>
           </div>
           <Input type="number" label="Indice" value={Indice} changeValue={setIndice}/>
           <Input type="number" label="Variables Simultaneas" value={VariablesSimultaneas} changeValue={setVariablesSimultaneas}/>
           <Input maxLines={4} label="Descripción" value={Descripcion} changeValue={setDescripcion}/>
           <Button style={{margin:"10px"}} variant="contained" color="primary" onClick={RedirectToVariables}>Variables</Button>
           <OpcionesModal opciones={Opciones}/>
           <SwitchState/>  
           <Button style={{margin:"10px"}} variant="text" color="primary" onClick={() => setEliminarOpen(true)}>Eliminar</Button>
       </DialogContent>
       <DialogActions>
           <Button variant="outlined" style={{color:"black"}} onClick={cancel}>Cancelar</Button>
           <Button variant="contained" style={{backgroundColor:"rgb(0, 136, 255)",color:"white"}} onClick={Confirm}>Confirmar</Button>
       </DialogActions>
   </Dialog>
   <RemoveDialog open={EliminarOpen} close={() => setEliminarOpen(false)} item={item}/>
   </>
}



export default EditItem
